var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampusesAddressesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.2,
    viewBox: "0 0 24 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "building-flag-solid",
    d: "M1.8,0A1.8,1.8,0,0,0,0,1.8V17.4a1.8,1.8,0,0,0,1.8,1.8H5.4v-3a1.8,1.8,0,1,1,3.6,0v3h3.6a1.8,1.8,0,0,0,1.8-1.8V1.8A1.8,1.8,0,0,0,12.6,0Zm.6,9A.6.6,0,0,1,3,8.4H4.2a.6.6,0,0,1,.6.6v1.2a.6.6,0,0,1-.6.6H3a.6.6,0,0,1-.6-.6Zm4.2-.6H7.8a.6.6,0,0,1,.6.6v1.2a.6.6,0,0,1-.6.6H6.6a.6.6,0,0,1-.6-.6V9A.6.6,0,0,1,6.6,8.4Zm3,.6a.6.6,0,0,1,.6-.6h1.2A.6.6,0,0,1,12,9v1.2a.6.6,0,0,1-.6.6H10.2a.6.6,0,0,1-.6-.6ZM3,3.6H4.2a.6.6,0,0,1,.6.6V5.4a.6.6,0,0,1-.6.6H3a.6.6,0,0,1-.6-.6V4.2A.6.6,0,0,1,3,3.6Zm3,.6a.6.6,0,0,1,.6-.6H7.8a.6.6,0,0,1,.6.6V5.4a.6.6,0,0,1-.6.6H6.6A.6.6,0,0,1,6,5.4Zm4.2-.6h1.2a.6.6,0,0,1,.6.6V5.4a.6.6,0,0,1-.6.6H10.2a.6.6,0,0,1-.6-.6V4.2A.6.6,0,0,1,10.2,3.6ZM16.8,0a1.2,1.2,0,0,0-1.2,1.2v18H18V7.2h5.4a.6.6,0,0,0,.6-.6V1.8a.6.6,0,0,0-.6-.6H18A1.2,1.2,0,0,0,16.8,0Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampusesAddressesIcon);
export default __webpack_public_path__ + "static/media/campuses-addresses-icon.f7d931e208c045fc43b08e7c2e7cf58a.svg";
export { ForwardRef as ReactComponent };